import { useEffect, useState } from 'react'
import Modal from 'react-modal'

const customStyles = {
    overlay: {
        zIndex: 2000,
        backgroundColor: 'rgba(0, 0, 0, 0.45)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2001
    }
}

export default ({ 
    isOpen,
    onAfterOpen,
    onRequestClose,
    contentLabel,
    title,
    body,
    footer,
    styles
}) => {
    const [open, setOpen] = useState(isOpen)
    useEffect(() => {
        setOpen(Boolean(isOpen))
    }, [isOpen])

    const _closeModal = () => { setOpen(false) }
    const modalStyles = {
        ...customStyles,
        ...styles,
        content: {
            ...customStyles.content,
            ...(styles?.content || {})
        },
        overlay: {
            ...(customStyles.overlay || {}),
            ...(styles?.overlay || {})
        }
    }

    return(
        <Modal
            isOpen={open}
            onAfterOpen={onAfterOpen || function noRefCheck() {} }
            onRequestClose={onRequestClose || _closeModal}
            contentLabel={contentLabel}
            style={modalStyles}
            className="jsmodal-dialog"
        >
            <div className='jsmodal-content'>
                <div className="jsmodal-header">
                    <h4 className="jsmodal-title">{title}</h4>
                    <button type="button" className='btn-close' onClick={onRequestClose || _closeModal}>
                        <span aria-hidden="true">&times;</span>
                        <span className="sr-only">Cerrar</span>
                    </button>
                </div>

                <div className='jsmodal-body'>
                    {body}
                </div>

                <div className='jsmodal-footer'>
                    {footer}
                </div>
            </div>
        </Modal>
    )
}
